module.exports = __webpack_public_path__ + "media/images/frontend/phone-d11f803dcc412c909113f9b99dbf0f6e.svg";